import { NewsInterface } from "../../../../core/components/news/domain/interfaces/news_interface";
import { NewsRepository } from "../../domain/repository/news_repository";
import { ActualityApiService } from "../data_source/actuality_api_service";


export class NewsRepositoryImpl implements NewsRepository {
    private actualityApiService: ActualityApiService;

    constructor() {
        this.actualityApiService = new ActualityApiService();
    }

    async getNewsById(id: string): Promise<NewsInterface> {
        const response = await this.actualityApiService.getActualityById(id);

        if (response.status == 200) {
            const news = response.data;
            const now = new Date();
            const startDate = new Date(news.startDate);
            const endDate = new Date(news.endDate);
            if (news.active && startDate <= now && endDate >= now) {
                return {
                    id: news._id,
                    ...news,
                }
            }
            throw new Error("News is not active or out of date range");
        }
        throw new Error("Failed to fetch news");
    }
}